import { render, staticRenderFns } from "./customerDetailsInq.vue?vue&type=template&id=6318e63c&"
import script from "./customerDetailsInq.vue?vue&type=script&lang=js&"
export * from "./customerDetailsInq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports